import React, { useEffect, useState } from "react";
import "./CreateCampaignTemplate.css";
import "./nameCampaign.css";
import Select, { components } from "react-select";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";

const validationSchema = Yup.object().shape({
  testTitle: Yup.object().required("Creative selection is required"),
  testDuration: Yup.object().required("Days selection is required"),
  costPerResult: Yup.object().required("Cost per result selection is required"),
});

const ABTesting = ({
  setIsFormThreeValid,
  setFormThreeValue,
  formThreeValue,
  reactSelectStyles,
}) => {
  return (
    <div className="campaign-budget-container pt-5">
      {" "}
      <div
        className="create-form-item"
        style={{ flexDirection: "column", alignItems: "baseline", gap: "5px" }}
      >
        <div className="title f-bold">A/B Test</div>

        <p className="description">
          Help improve ad performance by comparing versions to see what works
          best. For accuracy, each one will be shown to separate group of your
          audience.
        </p>
        <p
          style={{
            color: "blue",
            cursor: "pointer",
            textDecoration: "underline",
          }}
          className="f-12"
        >
          About A/B tests.
        </p>
      </div>
      <Formik
        initialValues={{
          testTitle: formThreeValue.testTitle || null,
          testDuration: formThreeValue.testDuration || null,
          costPerResult: formThreeValue.costPerResult || null,
        }}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          console.log("Form Submitted:", values);
        }}
      >
        {({ errors, touched, isValid, dirty, values, setFieldValue }) => {
          if (dirty) {
            setIsFormThreeValid(isValid && dirty);
            setFormThreeValue(values);
          }

          return (
            <Form>
              <div className="create-form-item">
                <div className="creative-container">
                  {/* <Select
          placeholder="Creative"
          options={[
            { label: "Highest Volume", value: "Highest" },
            { label: "Lowest Volume", value: "Lowest" },
          ]}
          styles={reactSelectStyles}
          // value={adType}
          // onChange={handleAdTypeChange}
        /> */}

                  <Select
                    styles={reactSelectStyles}
                    placeholder="Creative"
                    options={[
                      { label: "Highest Volume", value: "Highest" },
                      { label: "Lowest Volume", value: "Lowest" },
                    ]}
                    value={values.testTitle}
                    onChange={(option) => setFieldValue("testTitle", option)}
                  />
                  <ErrorMessage
                    name="testTitle"
                    component="div"
                    className="error"
                  />
                </div>
                <div className="ab-days-container">
                  {/* <Select
          placeholder="Days"
          options={[
            { label: "Highest Volume", value: "Highest" },
            { label: "Lowest Volume", value: "Lowest" },
          ]}
          styles={reactSelectStyles}

          // value={adType}
          // onChange={handleAdTypeChange}
        /> */}
                  <Select
                    styles={reactSelectStyles}
                    placeholder="Days"
                    options={[
                      { label: "Highest Volume", value: "Highest" },
                      { label: "Lowest Volume", value: "Lowest" },
                    ]}
                    value={values.testDuration}
                    onChange={(option) => setFieldValue("testDuration", option)}
                  />
                  <ErrorMessage
                    name="testDuration"
                    component="div"
                    className="error"
                  />
                </div>
                <div className="cost-per-result-container">
                  {/* <Select
          placeholder="cost per result"
          options={[
            { label: "Highest Volume", value: "Highest" },
            { label: "Lowest Volume", value: "Lowest" },
          ]}
          styles={reactSelectStyles}

          // value={adType}
          // onChange={handleAdTypeChange}
        /> */}

                  <Select
                    styles={reactSelectStyles}
                    placeholder="Select Cost Per Result"
                    options={[
                      { label: "Highest Volume", value: "Highest" },
                      { label: "Lowest Volume", value: "Lowest" },
                    ]}
                    value={values.costPerResult}
                    onChange={(option) =>
                      setFieldValue("costPerResult", option)
                    }
                  />
                  <ErrorMessage
                    name="costPerResult"
                    component="div"
                    className="error"
                  />
                </div>
              </div>
            </Form>
          );
        }}
      </Formik>
      <div
        className="create-form-item"
        style={{
          flexDirection: "column",
          alignItems: "baseline",
          gap: "5px",
        }}
      >
        <div className="title" style={{ fontWeight: "bold" }}>
          What happens after you publish
        </div>

        <p className="description">
          After you select Publish, we'll duplicate the campaign to create
          version B of your A/B test.
        </p>
      </div>
    </div>
  );
};

export default ABTesting;
